module.exports = __webpack_public_path__ + "static/media/ehealth_website_banner_desktop.b9e4a56e.jpg";